<template>
  <div>
    <b-card
        border-variant="secondary"
        text-variant="secondary"
        :title= "$t('help.portalHelpTitle')"
        align="center"
        style="max-width: 40rem;"
        class="mx-auto"
    >
      <b-card-text v-if="this.$store.getters.getPropertyInfo.tenantPortalHelpText !== undefined && this.$store.getters.getPropertyInfo.tenantPortalHelpText !== ''"  class="text-dark">{{this.$store.getters.getPropertyInfo.tenantPortalHelpText}}</b-card-text>
      <b-card-text v-else class="text-dark">{{$t('help.defaultText')}}</b-card-text>
    </b-card>
  </div>
</template>

<script>

import store from "../store/store";

export default {
  name: 'TenantPortalHelp',
  data: () => ({
    helpText:''
  }),
  async mounted () {
    await store.getters.getPropertyInfo
    if(store.getters.getPropertyInfo.tenantPortalHelpText !== ''){
      this.helpText = store.getters.getPropertyInfo.tenantPortalHelpText;
    }
  },
  methods: {
  }
}
</script>